import * as yup from 'yup';

export const createSchema = yup.object().shape({
  moq_id: yup.string().required(),

  supplier_id: yup.string().required(),

  shipping_fee: yup.string(),

  status: yup.string().required(),

  shipping: yup.string().required(),

  total_cost: yup.number(),

  order_remarks: yup.string(),
});

export const updateOrderStatusSchema = yup.object().shape({

    order_id_list: yup
        .array()
        .of(yup.number().required())
        .min(1, 'Minimum of 1 order allowed')
        .max(10, 'Maximum 10 orders allowed')
        .required('Orders is required'),

    status: yup.string().required(),

    eta: yup.date().required(),

});